
import Carousel from "react-material-ui-carousel";
import Stack from '@mui/material/Stack';
import React from 'react';
import Image from "./CarouselImage"
//import Modal from "./Modal"
export default function ImageCarousel(images) {

    //const [clickedImg, setClickedImg] = useState(null);
    // const [currentIndex, setCurrentIndex] = useState(null);


    // const handleClick = (item, index) => {
    //  setCurrentIndex(index);
    //  setClickedImg(item);
    //};
    // onClick={() => handleClick(item, index)} should be in the image component



    if (images.images.length <= 1) {
        return (
            <Stack>
                <Carousel animation="slide" autoPlay={false} indicators={false} swipe={false} height={200} navButtonsAlwaysInvisible={true}  >
                    {
                        images.images.map((url) => (

                            <Image
                                src={url}
                                alt={""}
                                height="99%" width="100%"
                            />
                        ))
                    }
                </Carousel>
            </Stack>
        );
    }
    else {
        return (
            <>
                <Stack>

                    <Carousel animation="slide" autoPlay={false} indicators={false} swipe={true} height={200} navButtonsAlwaysVisible={true} sx={{borderRadius:"3% 3% 0% 0%"}} >
              {images.images.map((url, index) => (
                            <div>
                                <Image
                                    src={url}
                                    alt={""}
                                    height="99%" width="100%"
                                />
                            </div>
                        ))}
                    </Carousel>
                </Stack>
            </>
            //   {clickedImg && (
            // <Modal
            //  clickedImg={clickedImg}
            //  setClickedImg={setClickedImg}
            //  />
            //  )}
        );


    }


}
